
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
    <g fill="none" fill-rule="evenodd">
        <rect width="24" height="17.778" x=".667" y="6.222" fill="#C7CFFF" rx="1.778"/>
        <path fill="#4562FF" d="M9.667 6.222h6V24h-6zM12.667 0l7 6.222h-14z"/>
    </g>
</svg>
